module.exports = __webpack_public_path__ + "static/media/4.d10f28b2.jpg";